'use client'

import * as React from 'react'  
import { FormFieldContextValue } from '../../types/FormFieldContextValue'

/**
 * @group Contexts
 * 
 * @summary
 * <blockquote>React context to provide the form field name to nested components.</blockquote>
 * 
 * @example
 * ```typescript
 * import { FormFieldContext } from '@shared/ui'
 * 
 * const fieldContext = React.useContext(FormFieldContext)
 * ```
 */
export const FormFieldContext = React.createContext<FormFieldContextValue>(
  {} as FormFieldContextValue
) 